import { EnMessageSeverity } from '../enum/en-message-severity.enum';

export interface IMessage {
    severity: EnMessageSeverity;
    summary: string;
    detail: string;
}
